import { createGetters, createMutations } from "vuelpers";
import { asig_perito, asig_asignacion } from "@/firebase/index";

const initialState = () => ({
  allPeritos: [],
  allAsignacion: []
})

const state = initialState()
const getters = createGetters("allPeritos", "allAsignacion");

const mutations = {
  ...createMutations('SET'),
  setPeritos(state, payload) {
    state.allPeritos = payload;
  },
  setAsignacion(state, payload) {
    state.allAsignacion = payload;
  }
};

const actions = {
  fetchPeritosData({ commit }) {
    return new Promise((resolve, reject) => {
      asig_perito.get().then(querySnapshot => {
        const allDocs = querySnapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
        commit("setPeritos", allDocs);
        resolve();
      });
    });
  },
  uploadPeritosData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      asig_perito.add(payload).then(() => {
        resolve();
      });
    });
  },
  fetchAsignacionData({ commit }) {
    return new Promise((resolve, reject) => {
      asig_asignacion.get().then(querySnapshot => {
        const allDocs = querySnapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
        commit("setAsignacion", allDocs);
        resolve();
      });
    });
  },
  uploadAsignacionData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      asig_asignacion.add(payload).then(() => {
        resolve();
      });
    });
  },
  resetState({ commit }) {
    commit("SET", initialState());
  }
};

export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};
